var map = {
	"./skinwt-01.mp3": [
		911,
		911
	],
	"./skinwt-02.mp3": [
		7033,
		33
	],
	"./skinwt-03.mp3": [
		8259,
		259
	],
	"./skinwt-04.mp3": [
		1813,
		813
	],
	"./triangle-01.mp3": [
		6674,
		674
	],
	"./triangle-02.mp3": [
		3419,
		419
	],
	"./triangle-03.mp3": [
		9074,
		74
	],
	"./triangle-04.mp3": [
		9278,
		278
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9321;
module.exports = webpackAsyncContext;